import { addDays, format } from 'date-fns';
import { toLocalMidnight } from '@/common/utils/dateFormats';

export const shiftDate = (anchor: string, daysChange: number): string | undefined => {
  const anchorDate = toLocalMidnight(anchor);
  return anchorDate ? format(addDays(anchorDate, daysChange), 'yyyy-MM-dd') : undefined;
};

export const shiftDateWithinRange = (
  anchor: string,
  daysChange: number,
  min: string,
  max: string,
): string | undefined => {
  const anchorDate = toLocalMidnight(anchor);
  const minDate = toLocalMidnight(min);
  const maxDate = toLocalMidnight(max);
  if (!anchorDate || !minDate || !maxDate) return undefined;

  const shifted = addDays(anchorDate, daysChange);
  const clamped = shifted < minDate ? minDate : shifted > maxDate ? maxDate : shifted;
  return format(clamped, 'yyyy-MM-dd');
};
